export default {
    data: {},
    loading: false,
    success: false,
    error: false,
    updatedData: {
        first_name: '',
        last_name: '',
        email_subscription: '',
    }
};
